/**
 * Created by mgoria on 11/23/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DescribeIdentityException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when describe cognito identity failed
 */
let DescribeIdentityException = exports.DescribeIdentityException = function (_Exception) {
  _inherits(DescribeIdentityException, _Exception);

  /**
   * @param {String} identityId
   * @param {Object} error
   */
  function DescribeIdentityException(identityId, error) {
    _classCallCheck(this, DescribeIdentityException);

    return _possibleConstructorReturn(this, (DescribeIdentityException.__proto__ || Object.getPrototypeOf(DescribeIdentityException)).call(this, `Error on describing cognito identity ${identityId}. ${error}`));
  }

  return DescribeIdentityException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/Exception/DescribeIdentityException.js
// module id = 436
// module chunks = 0